import { render, staticRenderFns } from "./kangbeiUploadImage.vue?vue&type=template&id=673a21f5&scoped=true"
import script from "./kangbeiUploadImage.vue?vue&type=script&lang=js"
export * from "./kangbeiUploadImage.vue?vue&type=script&lang=js"
import style0 from "./kangbeiUploadImage.vue?vue&type=style&index=0&id=673a21f5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673a21f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('673a21f5')) {
      api.createRecord('673a21f5', component.options)
    } else {
      api.reload('673a21f5', component.options)
    }
    module.hot.accept("./kangbeiUploadImage.vue?vue&type=template&id=673a21f5&scoped=true", function () {
      api.rerender('673a21f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fund/component/kangbeiUploadImage.vue"
export default component.exports